import { render } from "./RestrictionMeasureEditPage.vue?vue&type=template&id=0d5e3d36&scoped=true"
import script from "./RestrictionMeasureEditPage.vue?vue&type=script&lang=js"
export * from "./RestrictionMeasureEditPage.vue?vue&type=script&lang=js"

import "./RestrictionMeasureEditPage.vue?vue&type=style&index=0&id=0d5e3d36&scoped=true&lang=scss"
import "./RestrictionMeasureEditPage.vue?vue&type=style&index=1&id=0d5e3d36&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d5e3d36"]])

export default __exports__